import { IStores } from "./index";
import * as services from "services";
import { ListStoreConstructor } from "./ListStoreConstructor";
import { BidTransactionGridDto } from "interfaces";

export class BidTransactionList extends ListStoreConstructor<BidTransactionGridDto> {
  id: string = "";

  setId(id: string) {
    this.id = id;
  }

  constructor(stores: IStores) {
    super(
      stores,
      (params) => {
        return services.getBidTransactionList({ requestId: this.id }, params).then(
          (response) =>
            ({
              content: response.content || [],
              size: response.size || 0,
              totalPages: response.totalPages || 0,
              totalElements: response.totalElements || 0,
            }) as any
        );
      },
      {
        pollingInterval: 10000,
        sorters: {
          date: "desc",
        },
      }
    );
  }
}
